module.exports = __webpack_public_path__ + "fonts/Poppins-Thin.654968a.woff";